import { en } from './en';
import { cs } from './cs';
import { sk } from './sk';

import type { Locale } from '../locale';
import type { LocaleDict } from '../types';

export const dictionaries = { en, cs, sk } as const satisfies Record<Locale, LocaleDict>;

export type { Locale } from '../locale';